import { useEffect, useMemo, useState } from 'react';

import { useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';

import { STEPS } from 'components/modules/Insurance/Insurance.constants';
import { Insurance } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';
import {
  PAGES_VALUE_FIELDS,
  SHARED_ERROR_AND_WARNING_VALUE_FIELDS,
} from 'store/insurance/constants';
import { selectPage } from 'store/insurance/selectors';

const { ROUTES } = Insurance;

export const usePatchingSuccessfully = () => {
  const history = useHistory();

  const { params, route } = useRouteMatch({ routes: ROUTES }) ?? {};
  const { id: worksheetId } = params ?? {};

  const { [PAGES_VALUE_FIELDS.ERROR]: error, [PAGES_VALUE_FIELDS.PATCHING]: patching } =
    useSelector(selectPage(route));
  const { [SHARED_ERROR_AND_WARNING_VALUE_FIELDS.TYPE]: type } = error;

  const nextRoute = useMemo(() => {
    for (let i = 0; i < STEPS.length; i++) {
      const { routes: currentRoutes } = STEPS[i];
      const { routes: nextRoutes } = STEPS[i + 1] ?? {};

      if (currentRoutes.has(route) && typeof nextRoutes !== 'undefined') {
        const { value } = nextRoutes.keys().next();

        return value;
      }
    }
  }, [route]);
  const nextPathname = useMemo(() => {
    if (!nextRoute || !worksheetId) {
      return;
    }

    return generatePath(ROUTES[nextRoute].path, { id: worksheetId });
  }, [nextRoute, worksheetId]);

  const [watch, setWatch] = useState(false);

  useEffect(
    () => {
      const hasError = typeof type !== 'undefined';

      if (!watch || patching || hasError || !nextPathname) {
        return;
      }

      history.push(nextPathname);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [watch, patching, type]
  );

  useEffect(() => {
    if (!patching) {
      return;
    }

    setWatch(true);
  }, [patching]);
};
